<span class="badge a_ml_1 a_mt_0" v-if="numUnread &gt; 0" v-translate="translateTitleOptions">{{ numUnread }}</span>